import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Sanitizer } from '@angular/core';


@Pipe({
  name: 'generateAndDisplayMediaTags',
  standalone: true
})

export class GenerateAndDisplayMediaTagsPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  // allowedTags: string[] = ["script", "iframe", "video", "source", "img", "qr-code"];
  // allowedAttributes: string[] = ['src', 'href', 'width', 'height', 'controls', 'autoplay', 'loop', 'muted', 'poster', 'allow', 'allowfullscreen', 'type', 'style', 'class', 'id', 'alt', 'title'];
  // iframe: any;


  transform(jobDescription: any): SafeHtml | null {
    if (jobDescription != null && jobDescription != "") {
      jobDescription = this.displayImages(jobDescription);
      jobDescription = this.displayVideos(jobDescription);
      jobDescription = this.generateAndDisplayQRCodesJobApply(jobDescription);
      jobDescription = this.generateAndDisplayQRCodes(jobDescription);
    }

    const sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(jobDescription);
    return sanitizedHtml;
  }
  displayImages(jobDescription: any): any {
    let ImageTag = "<IMG";
    let ReplaceImageTag = "alt";
    // Check if jobDescription is a string before performing string operations
    if (typeof jobDescription === 'string') {
      jobDescription = jobDescription.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
      if (jobDescription.includes(ImageTag) || jobDescription.includes(ImageTag.toLowerCase())) {
        const oRegExp = new RegExp("<(img).+?src=[\"'](.+?)[\"'].*?>", 'gi');
        const allImageTags = jobDescription.match(oRegExp);
        if (allImageTags) {
          allImageTags.forEach((eachTag: string) => {
            let tempTag = eachTag;
            const insertIndex = ImageTag.length + 1;

            // Helper to insert string at position
            const insertAt = (str: string, sub: string, pos: number) => str.slice(0, pos) + sub + str.slice(pos);

            tempTag = insertAt(tempTag, "tabindex='0' ", insertIndex);

            if (!(tempTag.includes(ReplaceImageTag) || tempTag.includes(ReplaceImageTag.toUpperCase()))) {
              tempTag = insertAt(tempTag, ReplaceImageTag + "='Job related Image' ", insertIndex);
            }
            jobDescription = jobDescription.replace(eachTag, tempTag);
          });
        }
      }
    }

    return jobDescription;
  }
  displayVideos(jobDescription: any): any {
    // Implement video display logic here
    let temp1 = -1;
    let temp2 = -1;
    let videoUrl = "";
    let videoTag = "";
    let iframeSrc = "";
    let iframeText = "";
    let videoCodeYouTube = "";
    let queryString = "";
    let arrQStringParms = null;
    let vimeocode = "";
    let metacafeCode = "";
    let metacafeVideoHtml = "";
    let strWidthHeight = "";
    let arrWidthHeight = null;
    let strWidth = "";
    let strHeight = "";
    if (jobDescription.indexOf("[#video#") != -1) {
      temp1 = jobDescription.indexOf("[#video#");
      temp2 = jobDescription.indexOf("#/video#]");
      if (temp1 >= 0 && temp2 > temp1) {
        videoUrl = jobDescription.substring(temp1 + 8, temp2);
        ///Suppporting width and height
        if (videoUrl.indexOf("{#") != -1) {
          strWidthHeight = videoUrl.substring(videoUrl.indexOf("{#") + 2, videoUrl.indexOf("#}"));
          if (strWidthHeight != "") {
            arrWidthHeight = strWidthHeight.split(',');
            if (arrWidthHeight.length > 1) {
              strWidth = arrWidthHeight[0];
              strHeight = arrWidthHeight[1];
            }
          }
          if (strWidth == "") {
            strWidth = "400";
          }

          if (strHeight == "") {
            strHeight = "300";
          }
          strWidthHeight = "max-width:100%;width:" + strWidth + "px;height:" + strHeight + "px";

          videoTag = "[#video#" + videoUrl + "#/video#]";

          videoUrl = videoUrl.replace("{#" + strWidth + "," + strHeight + "#}", "");
          if (videoUrl.indexOf("youtube.com/") != -1) {
            if (videoUrl.indexOf("?") != -1) {
              queryString = videoUrl.substring(videoUrl.indexOf("?") + 1);
              if (queryString.indexOf("&") != -1) {
                arrQStringParms = queryString.split('&');
                for (let idx = 0; idx < arrQStringParms.length; idx++) {
                  if (arrQStringParms[idx].indexOf("v=") != -1) {
                    videoCodeYouTube = arrQStringParms[idx].substring(2);
                  }
                }
              }
              else if (queryString.indexOf("v=") != -1) {
                videoCodeYouTube = queryString.substring(2);
              }


            }
          }
          else {
            videoCodeYouTube = videoUrl.substring((videoUrl.lastIndexOf("/") + 1), ((videoUrl.length) - videoUrl.lastIndexOf("/") - 1));
          }
          iframeSrc = "https://www.youtube.com/embed/" + videoCodeYouTube + "?wmode=transparent";
          iframeText = "\n\n<iframe id=" + iframeSrc + " title='Job video' src=" + iframeSrc + " style='" + strWidthHeight + "' type='text/html' frameborder='0'></iframe>\n\n";
          jobDescription = jobDescription.replace(videoTag, iframeText);
        }
        else if (videoUrl.indexOf("youtu.be") != -1) {
          videoCodeYouTube = videoUrl.substring((videoUrl.lastIndexOf("/") + 1), ((videoUrl.length) - videoUrl.lastIndexOf("/") - 1));
          iframeSrc = "https://www.youtube.com/embed/" + videoCodeYouTube + "?wmode=transparent";
          iframeText = "\n\n<iframe id=" + iframeSrc + " title='Job video' src=" + iframeSrc + " style='" + strWidthHeight + "' type='text/html' frameborder='0'></iframe>\n\n";
          jobDescription = jobDescription.replace(videoTag, iframeText);

        }
        else if (videoUrl.indexOf("youtube-nocookie.com") != -1) {
          videoCodeYouTube = videoUrl.substring((videoUrl.lastIndexOf("/") + 1), ((videoUrl.length) - videoUrl.lastIndexOf("/") - 1));
          iframeSrc = "https://www.youtube-nocookie.com/embed/" + videoCodeYouTube + "?wmode=transparent";
          iframeText = "\n\n<iframe id=" + iframeSrc + " title='Job video' src=" + iframeSrc + " style='" + strWidthHeight + "' type='text/html' frameborder='0'></iframe>\n\n";
          jobDescription = jobDescription.replace(videoTag, iframeText);

        }
        else if (videoUrl.indexOf("vimeo.com/") != -1) {
          vimeocode = videoUrl.substring((videoUrl.lastIndexOf("/") + 1), ((videoUrl.length) - videoUrl.lastIndexOf("/") - 1));
          iframeSrc = "https://player.vimeo.com/video/" + vimeocode + "?wmode=transparent";
          iframeText = "\n\n<iframe id = " + iframeSrc + " title='Job video' src=" + iframeSrc + " style='" + strWidthHeight + "' type='text/html' frameborder='0'></iframe>\n\n";
          jobDescription = jobDescription.replace(videoTag, iframeText);
        }
        else if (videoUrl.indexOf("metacafe.com") != -1) {
          //https://www.metacafe.com/watch/8456245/trailers_call_of_duty_black_ops_2_reveal_trailer
          metacafeCode = videoUrl.substring(videoUrl.indexOf("https://www.metacafe.com/watch/") + ("https://www.metacafe.com/watch".length) + 1);
          if (metacafeCode.substring(metacafeCode.length - 1) == "/" || metacafeCode.substring(metacafeCode.length - 1) == "\\") {
            metacafeCode = metacafeCode.substring(0, metacafeCode.length - 1);
          }
          metacafeVideoHtml = "\n\n<div id=" + metacafeCode + " style='" + strWidthHeight + "'><embed flashVars='playerVars=autoPlay=no' src='https://www.metacafe.com/fplayer/" + metacafeCode + ".swf' width='" + strWidth + "' height='" + strHeight + "' wmode='transparent' allowFullScreen='true' allowScriptAccess='always'  pluginspage='https://www.macromedia.com/go/getflashplayer' type='application/x-shockwave-flash'></embed></div>\n\n";
          jobDescription = jobDescription.replace(videoTag, metacafeVideoHtml);

        }
        else {
          jobDescription = jobDescription.replace(videoTag, "");
        }



      }
      else if (temp1 >= 0 && temp2 <= temp1) {
        return jobDescription;
      }
      return this.displayVideos(jobDescription);

    }
    else {
      return jobDescription;
    }

  }
  generateAndDisplayQRCodesJobApply(qrcodeString: any): string {
    let temp1 = qrcodeString.indexOf("[#qrcode#Jobapply");
    let temp2 = qrcodeString.indexOf("#/qrcode#]", temp1);
    let strWidth = "";
    let strHeight = "";
    let arrWidthHeight: string[] = [];
    let qrSource = "";
    let jobDetailPageURL = "";
    let qrCodeImg;
    let strReplaceJobApplyQR;
    let jobDescription = qrcodeString;

    if (qrcodeString.indexOf("[#qrcode#Jobapply") != -1) {

      if (temp1 >= 0 && temp2 > temp1) {
        let urlText = qrcodeString.substring(temp1 + 17, temp2);// Here you might want to extract the portion that contains the QR code
        if (urlText.indexOf("{#") != -1) {
          let strWidthHeight = urlText.substring(urlText.indexOf("{#") + 2, urlText.indexOf("#}"))
          // let strWidthHeight = urlText.substring(urlText.indexOf("{#") + 2, (urlText.length) - (urlText.indexOf("{#") + 4));
          if (urlText.indexOf("{#") != -1) {
            strWidthHeight = urlText.substring(urlText.indexOf("{#") + 2, urlText.indexOf("#}"));
            if (strWidthHeight != "") {
              arrWidthHeight = strWidthHeight.split(',');
              if (arrWidthHeight.length > 1) {
                strWidth = arrWidthHeight[0];
                strHeight = arrWidthHeight[1];
              }
            }
          }
          if (strWidth == "") {
            strWidth = "200";
          }

          if (strHeight == "") {
            strHeight = "200";
          }
          strWidthHeight = "max-width:100%;width:" + strWidth + "px;height:" + strHeight + "px;border:0px";
          qrSource = "/TGNewUI/Search/Home/GenerateQRcode?jobDetailPageURL=" + jobDetailPageURL;
          qrCodeImg = "\n\n<img tabindex='0' id = " + qrSource + " alt='QRcodes' src=" + qrSource + " style='" + strWidthHeight + "'></img>\n\n";
          strReplaceJobApplyQR = "[#qrcode#Jobapply{#" + strWidth + "," + strHeight + "#}#/qrcode#]";

          jobDescription = jobDescription.replace(strReplaceJobApplyQR, qrCodeImg);
          return this.generateAndDisplayQRCodesJobApply(jobDescription);
        }
        else {
          return jobDescription
        }
      }
    }
    return jobDescription;
  }

 generateAndDisplayQRCodes(jobDescription: string): string {
  let temp1: number = -1;
  let temp2: number = -1;
  let urlText: string = '';
  let qrTag: string = '';
  let qrSource: string = '';
  let iframeText: string = '';
  let strWidthHeight: string = '';
  let arrWidthHeight: string[] | null = null;
  let strWidth: string = '';
  let strHeight: string = '';

  if (jobDescription.indexOf('[#qrcode#') !== -1) {
    temp1 = jobDescription.indexOf('[#qrcode#');
    temp2 = jobDescription.indexOf('#/qrcode#]');

    if (temp1 >= 0 && temp2 > temp1) {
      urlText = jobDescription.substring(temp1 + 9, temp2);

      // Supporting width and height
      if (urlText.indexOf('{#') !== -1) {
        strWidthHeight = urlText.substring(urlText.indexOf('{#') + 2, urlText.length - (urlText.indexOf('{#') + 4));
        if (strWidthHeight !== '') {
          arrWidthHeight = strWidthHeight.split(',');
          if (arrWidthHeight.length > 1) {
            strWidth = arrWidthHeight[0];
            strHeight = arrWidthHeight[1];
          }
        }
      }

      if (strWidth === '') {
        strWidth = '200';
      }

      if (strHeight === '') {
        strHeight = '200';
      }

      // Build this variable
      strWidthHeight = `width:${strWidth}px;height:${strHeight}px;border:0px`;

      qrTag = `[#qrcode#${urlText}#/qrcode#]`;
      urlText = urlText.replace(`{#${strWidth},${strHeight}#}`, '');
      qrSource = `/TGNewUI/Search/Home/GenerateQRcode?jobDetailPageURL=${urlText}`;

      iframeText = `\n\n<img tabindex='0' id="${qrSource}" alt='QrCodes' src="${qrSource}" style="${strWidthHeight}"></img>\n\n`;

      jobDescription = jobDescription.replace(qrTag, iframeText);
    }

    return this.generateAndDisplayQRCodes(jobDescription);
  } else {
    return jobDescription;
  }
}



}

